import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { SelectBankAccountModule } from '@shared/select-bank-account/select-bank-account.module';
import { ValidationCodeModule } from '@shared/validation-code/validation-code.module';
import { MatDialogCustomModule } from '../mat-dialog-custom/mat-dialog-custom.module';
import { WithdrawMoneyComponent } from './withdraw-money.component';
import { CurrencyCountryPipeModule } from '@pipes/currency-country/currency-country.module';
import { TableCardModule } from '@shared/mat-table-card/table-card.module';
import { MaskAccountNumberModule } from '@pipes/mask-account-number/mask-account-number.module';
import { PreventScrollDirective } from '@shared/prevent-scroll-directive/prevent-scroll.directive';
import { NgxMaskDirective } from 'ngx-mask';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TextFieldModule } from '@angular/cdk/text-field';
import { WithdrawMoneyV1Component } from './withdraw-money-v1/withdraw-money-v1.component';
import { WithdrawMoneyV2Component } from './withdraw-money-v2/withdraw-money-v2.component';

@NgModule({
  declarations: [
    WithdrawMoneyComponent,
    WithdrawMoneyV1Component,
    WithdrawMoneyV2Component,
  ],
  imports: [
    SharedModule,
    MatDialogCustomModule,
    SelectBankAccountModule,
    ValidationCodeModule,
    CurrencyCountryPipeModule,
    TableCardModule,
    MaskAccountNumberModule,
    PreventScrollDirective,
    NgxMaskDirective,
    MatCheckboxModule,
    TextFieldModule,
  ],
  exports: [
    WithdrawMoneyComponent,
    WithdrawMoneyV1Component,
    WithdrawMoneyV2Component,
  ],
})
export class WithdrawMoneyModule {}
